export default __webpack_public_path__ + "static/media/stock.93823b1c.jpg";